<script setup>
const props = defineProps({
    lead: {
        type: Object,
        required: true,
    },
    // When false, emit 'deleted' instead of navigating to the lead list (e.g. in the quickview slideout).
    redirectAfterDelete: {
        type: Boolean,
        required: false,
        default: true,
    },
})

const emit = defineEmits(['reload:lead', 'archived', 'deleted'])
</script>

<template>
    <div class="flex items-center space-x-2">
        <lead-actions-button
            :lead="lead"
            :allow-archive="true"
            :redirect-after-delete="redirectAfterDelete"
            @reload:lead="emit('reload:lead')"
            @archived="emit('archived')"
            @deleted="emit('deleted')"
        />

        <lead-closer-actions :lead="lead" />
    </div>
</template>
